module.exports = __webpack_public_path__ + "img/02.ac5aab4c.png";